import React from "react";
import { Truck, ShieldCheck, FlaskConical, Sparkles } from "lucide-react";
import { BRAND } from "../mock";

const items = [
  { icon: Truck, text: "FREE U.S. SHIPPING ON ORDERS OVER $200" },
  { icon: ShieldCheck, text: "3RD-PARTY LAB TESTED — COA ON EVERY BATCH" },
  { icon: FlaskConical, text: "MADE IN THE USA — FOR RESEARCH USE ONLY" },
  { icon: Sparkles, text: `USE CODE ${BRAND.coupon} FOR 10% OFF YOUR FIRST ORDER` },
];

const AnnouncementBar = () => {
  const loop = [...items, ...items];
  return (
    <div className="bg-[#0a0a0a] text-white text-[12px] tracking-wide overflow-hidden border-b border-white/10">
      <div className="marquee py-2">
        {loop.map((it, idx) => {
          const Icon = it.icon;
          return (
            <div key={idx} className="flex items-center gap-2 shrink-0">
              <Icon className="h-3.5 w-3.5 text-red-400" />
              <span className="font-semibold">{it.text}</span>
              <span className="text-white/40">•</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnnouncementBar;
